
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asisten-guru",
      function () {
        return require("private-next-pages/asisten-guru/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asisten-guru"])
      });
    }
  